export { default } from './GroupRegistrationUploadPage';
